import { FleetEntry } from "@shared/platform-api/generated"
import { createRequest, platform } from "@shared/platform-api/requests"
import { FindFleetInput, FindFleetModernInput, FleetEntryInput, PaginatedResponse } from "@shared/types"
import { convertEntryToLegacy } from "@shared/utils/compatibility"
import { createRequestHook } from "../../createRequestHook"
import { Fleet, FleetEntry as LegacyFleetEntry, makeFleet } from "../types"

export type WithVrns<T> = T & Readonly<{ connectedVrns: ReadonlyArray<string> }>

export const findModernPaginatedFleetAsLegacy = createRequest<
  WithVrns<FleetEntryInput>,
  PaginatedResponse<LegacyFleetEntry>
>(async ({ connectedVrns, ...input }, getToken) => {
  const data = await platform(getToken).fleets.fleetEntries(input)
  const items = data?.items?.map(convertEntryToLegacy(connectedVrns))

  return { ...data, items }
})

export const findModernPaginatedFleet = createRequest<FleetEntryInput, PaginatedResponse<FleetEntry>>(
  async (input, getToken) => {
    const modernPaginated = await platform(getToken).fleets.fleetEntries(input)
    return modernPaginated
  }
)

const fleetForModernPolicies = async (
  { connectedVrns, ...input }: WithVrns<FindFleetModernInput>,
  getToken: () => Promise<string>
): Promise<Fleet> => {
  const { data, tag } = await findModernPaginatedFleet(input, getToken)

  if (tag === `err`) {
    throw new Error(`Error finding fleets`)
  }

  const entries = data.items.map(convertEntryToLegacy(connectedVrns))

  return makeFleet(entries)
}

export const useFindFleet = createRequestHook(
  createRequest<WithVrns<FindFleetInput>, Fleet>(async (input, getToken) => fleetForModernPolicies(input, getToken))
)
